import api from '../../api/axios';
import store from '../store';
import constants from '@/config/constants';
import { Session } from '@/components/SharedComponents/SessionsList';
import encryptedStorage from '../encryptedStorage';
import { AxiosResponse } from 'axios';
import { User } from '../store.types';

type UserData = {
  accessToken: string;
  user: User;
};

export const localLoginUser = async (data: UserData) => {
  store.getActions().setIsAuthenticated(true);
  if (constants.appMode === 'therapist') {
    store.getActions().setPatternLockInfo({
      appStartResumeLock: data.user.appStartResumeLock,
      eigentrainingLock: data.user.eigentrainingLock,
      appLockPattern: data.user.appLockPattern,
    });
  }
  store.getActions().setUserData(data);
  return;
};

export const serverForgotPassword = (
  payload: unknown,
): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {
    api
      .post('/api/auth/forgot', payload)
      .then((res) => {
        return resolve(res);
      })
      .catch((error) => reject(error));
  });
};

export const serverMultiLogoutUser = (jwts: string) => {
  return api.post('/api/auth/multisignout', { credentialsToBeRemoved: jwts });
};

export const serverLogoutUser = (payload: { jwt: string }) => {
  if (payload.jwt && payload.jwt.length > 2) {
    return api.post('/api/auth/signout/v2', payload);
  } else {
    return null;
  }
};

export const getSessions = async (): Promise<Session[]> => {
  try {
    const res = await api.get<Session[]>('/api/users/sessions');
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const refreshUserLoggedInState = async () => {
  if (store.getState().isAuthenticated) {
    store.getActions().setIsAuthenticated(true);
    store.getActions().setUserData(store.getState().signedInUser);
  } else {
    store.getActions().setUserData({});
  }
};

export const clearLocalData = async () => {
  await store.persist.clear();
  await encryptedStorage().clear();
};

export const getAccessToken = async () => {
  if (!store.getState().isAuthenticated) {
    return '';
  }
  return store.getState()?.signedInUser?.accessToken;
};

export const getUser = async () => {
  if (!store.getState().isAuthenticated) {
    return '';
  } else {
    return store.getState().signedInUser?.user;
  }
};
